"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var angular = require("angular");
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
require('../issue-view/issue-view.component.css');
var ISSUE_TYPE_COLOR = {
    Discovery: "#FFEAF4",
    Specify: "#FFFFB7",
    Navigate: "#C6DCFB",
    Manage: "#CFFFEE"
};
var IssueViewComponent = /** @class */ (function () {
    function IssueViewComponent($rootScope, $scope, $timeout) {
        this.issueConfig = {};
        this.disableEdit = false;
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.DEFAULT);
        ctrl.$scope = $scope;
        ctrl.$timeout = $timeout;
        ctrl.$rootScope = $rootScope;
        ctrl.dashboardExpPriority = false;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        ctrl.showGenerateBtn = false;
        ctrl.guideCommand = '';
        ctrl.stopLoadingSpinner = function () {
            $scope.$emit('workbench:loading', { 'load': false });
        };
        $scope.$on('command:ISSUE_VIEW', function (event, args) {
            ctrl.disableEdit = (args.node.permissions == 'r');
            ctrl.guideCommand = '';
            ctrl.initComponent(event, args);
            ctrl.getNColCanvasConfig();
            ctrl.clearDivs();
        });
        $timeout();
        $('select option')
            .filter(function () {
            return !this.value || $.trim(this.value).length == 0 || $.trim(this.text).length == 0;
        })
            .remove();
    }
    IssueViewComponent.prototype.setGlobalDirty = function () {
        var ctrl = this;
        ctrl.$timeout(function () {
            ctrl.$rootScope.smartorgDirty = ctrl.isDirty;
        }, 0);
    };
    IssueViewComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem ? args.actionMenuItem : "Issue View";
        ctrl.nodeName = args.node.name;
        ctrl.fteGlobal = args.fte;
        ctrl.tornadoFactors = args.factors;
        ctrl.tornadoFactors.forEach(function (f) {
            f['Comment'] = decodeURIComponent(f['Comment']);
        });
        ctrl.tornadoFactors = ctrl.tornadoFactors.concat([
            { 'Factor': 'Chance of Failure - High (75% to 100%)', 'Comment': '' },
            { 'Factor': 'Chance of Failure - Middle (Around 50%)', 'Comment': '' },
            { 'Factor': 'Chance of Failure - Low (Less than 25%)', 'Comment': '' }
        ]);
        ctrl.origTornadoFactors = angular.copy(ctrl.tornadoFactors);
        ctrl.origStatus = ["Completed", "In Plan", "Backlog", "Unplanned"];
        ctrl.node = args.node;
        ctrl.isQualitative = false;
        if ('inavImpactType' in ctrl.node) {
            ctrl.isQualitative = ctrl.node['inavImpactType'] == 'Qualitative';
        }
        ctrl.issueData = [];
        ctrl.selectedIssue = null;
        ctrl.isDirty = false;
        ctrl.getIssueDetailsFromDb();
        ctrl.menu = [];
        ctrl.setGlobalDirty();
        // Handsonetable Setting
        ctrl.settings = {
            colHeaders: true,
            stretchH: "all",
            colWidths: ["15vw", "9vw", "8vw", "11vw", "11vw", "11vw", "13vw"],
            nestedHeaders: [
                [{ label: '', colspan: 3 }, { label: 'Impact Factors', colspan: 3 }, { label: '', colspan: 1 },],
                ['Issue', 'Issue Type', 'Surprise Index', '1st', '2nd', '3rd', 'Experiment'],
            ],
            // height: "60vh",
            width: "90vw",
            licenseKey: "ee979-f3485-d8862-46b42-8ee23",
            cells: function (row, col) {
                var cellPrp = {};
                cellPrp.className = (col == 6) ? 'htLeft htMiddle cursor-pointer' : 'htCenter htMiddle';
                if (col === 1) {
                    cellPrp.renderer = ctrl.IssueTypeRenderer;
                }
                if (col === 2) {
                    cellPrp.renderer = ctrl.ReadinessRenderer;
                }
                if (col === 3 || col === 4 || col === 5) {
                    cellPrp.renderer = ctrl.impactFactorRenderer;
                }
                // if (col === 4) {
                //     cellPrp.renderer = ctrl.myRenderer;
                // }
                return cellPrp;
            },
            // afterDropdownMenuShow(instance) {
            //     var filters = instance.hot.getPlugin('filters');
            //         console.log(filters.valueComponent)
            //       filters.components.get('filter_by_value').elements[0].onClearAllClick({preventDefault: function() {}});
            // },
            afterOnCellMouseDown: function (event, coords) {
                var indexGotHere = this.toPhysicalRow(coords.row);
                if (coords.col == 6 && coords.row != -1) {
                    ctrl.selectIssue(indexGotHere);
                }
                ctrl.$scope.$apply();
            },
            afterGetColHeader: function (col, TH) {
                if (col === 2) {
                    var button = TH.querySelector(".changeType");
                    if (!button) {
                        return;
                    }
                    button.parentElement.removeChild(button);
                }
            },
            viewportColumnRenderingOffset: 70,
            dropdownMenu: [
                "filter_by_value",
                "filter_action_bar",
                "filter_by_condition",
            ],
            filters: true,
            columnSorting: true
        };
    };
    IssueViewComponent.prototype.getNColCanvasConfig = function () {
        var ctrl = this;
        var config = ctrl.utilsService.getIssueConfigFromStorage(true);
        ctrl.display = config.title;
        ctrl.issueConfig = config.issueConfig;
    };
    IssueViewComponent.prototype.showTable = function () {
        var ctrl = this;
        ctrl.clearDivs();
        ctrl.loadHotTableConfig();
        ctrl.isDataLoaded = true;
        var issueViewTable = document.getElementById('issue-view-table');
        var hotIssue = new Handsontable(issueViewTable, __assign(__assign({}, ctrl.settings), { colHeaders: ctrl.colHeaders, columns: ctrl.columns, data: ctrl.issueData }));
    };
    IssueViewComponent.prototype.loadHotTableConfig = function () {
        var ctrl = this;
        ctrl.dropdownMenu = [
            "filter_by_value",
            "filter_action_bar",
            "filter_by_condition",
        ];
        ctrl.colHeaders = [
            "Issue",
            "Issue Type",
            "Surprise Index",
            "1st",
            "2nd",
            "3rd",
            "Experiment",
        ];
        ctrl.colWidths = ["15vw", "9vw", "8vw", "11vw", "11vw", "11vw", "13vw"];
        // height: "60vh",
        // width: "70vw",
        ctrl.columns = [
            { data: "name", className: "htLeft htMiddle cursor-pointer", readOnly: true },
            { data: "issueType", className: "htCenter htMiddle", readOnly: true },
            {
                data: "readiness",
                className: "htCenter htMiddle",
                readOnly: true,
                columnSorting: {
                    sortEmptyCells: false,
                    indicator: true,
                    headerAction: true,
                    compareFunctionFactory: function (sortOrder, columnMeta) {
                        return function (value, nextValue) {
                            // if asc return 1 for greater else -1 for greater
                            var comp = value.score - nextValue.score;
                            return sortOrder == 'asc' ? comp * -1 : comp;
                        };
                    }
                }
            },
            { data: "impactFactorFirst", className: "htCenter htMiddle", readOnly: true },
            { data: "impactFactorSecond", className: "htCenter htMiddle", readOnly: true },
            { data: "impactFactorThird", className: "htCenter htMiddle", readOnly: true },
            { data: "expName", className: "htCenter htMiddle", readOnly: true },
        ];
    };
    IssueViewComponent.prototype.clearDivs = function () {
        try {
            document.getElementById('issues-handson').innerHTML = "";
        }
        catch (e) {
        }
    };
    IssueViewComponent.prototype.IssueTypeRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        td.style.backgroundColor = ISSUE_TYPE_COLOR[value];
        // console.log(value, discoveryQuadrant[value.replace(/ /g, "")]);
    };
    IssueViewComponent.prototype.impactFactorRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        var tooltip = '';
        var reason = '';
        // [0]-> display, [1]-> impactScore, [2]-> isPotentialShowStopper, [3]-> optimism/high [4]-> pessimism/low
        var values = value ? value.split("<>") : ['', 0, false, '', ''];
        if (values) {
            // isPotentialShowStopper
            if (values[2] == 'true') {
                reason = "Reason for Optimism: " + values[3] + " &#013;Reason for Pessimism: " + values[4] + " &#013; &#013;";
            }
            else {
                reason = "Reason for High: " + values[3] + " &#013;Reason for Low: " + values[4] + " &#013; &#013;";
            }
            var impactScore = "Impact Score: " + values[1];
            tooltip = reason + impactScore;
        }
        else {
            tooltip = "No data to be displayed";
        }
        td.innerHTML = "<span title='" + tooltip + "'>" + values[0] + "</span>";
    };
    IssueViewComponent.prototype.ReadinessRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        var ctrl = this;
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        // const values = value ? value.split(",") : [0,0,0]; // score[0], ignorance[1], impact[2]
        // const values = [value.score, value.ignorance, value.impact];
        var tooltip = value ? "Ignorance: " + value.ignorance + " &#013;Impact Score: " + value.impact + " &#013; &#013;" : 'No data to be displayed';
        td.innerHTML = "<span title='" + tooltip + "'>" + ((value && value.score) ? value.score : 0) + "</span>";
    };
    IssueViewComponent.prototype.discoveryGrid = function (ignorance, impact) {
        return ignorance >= 5 && impact >= 5
            ? "Discovery"
            : ignorance >= 5 && impact < 5
                ? "Specify"
                : ignorance < 5 && impact >= 5
                    ? "Navigate"
                    : "Manage";
    };
    IssueViewComponent.prototype.selectFactor = function () {
        var ctrl = this;
        ctrl.currExperiment.issueFactor = ctrl.selectedFactor;
        ctrl.checkSave();
    };
    IssueViewComponent.prototype.selectStatus = function () {
        var ctrl = this;
        ctrl.currExperiment.status = ctrl.selectedStatus;
        ctrl.checkSave();
    };
    IssueViewComponent.prototype.getDefined = function () {
        var ctrl = this;
        var total = 8;
        var done = 0;
        if (ctrl.currExperiment.expName)
            done++;
        if (ctrl.currExperiment.needToLearn)
            done++;
        if (ctrl.currExperiment.goingToLearn)
            done++;
        if (ctrl.currExperiment.toMeasure)
            done++;
        if (ctrl.currExperiment.successCriteria)
            done++;
        if (ctrl.currExperiment.cost)
            done++;
        if (ctrl.currExperiment.duration)
            done++;
        if (ctrl.currExperiment.resourceFte)
            done++;
        return Math.round((done * 100) / total);
    };
    IssueViewComponent.prototype.getIssueDetailsFromDb = function () {
        var ctrl = this;
        ctrl.smartorg.getInavIssueExperimentAndTornado(ctrl.node['_id']).then(function (res) {
            if (res.status == 1) {
                ctrl.stopLoadingSpinner();
                ctrl.showAlert('danger', 'Error!', res.message);
            }
            else {
                ctrl.impactFactorScoreList = ctrl.getCalculateImpactFactorScore(res.tornado_npv_swing);
                ctrl.issueData = res.issueAndExperiment.map(function (item) {
                    var formatted = ctrl.utilsService.formatIssueData(item, ctrl.isQualitative, ctrl.fteGlobal);
                    formatted.impactMappingList = ctrl.getImpactMappingListWithImpactScore(item);
                    return formatted;
                });
                ctrl.issueData.sort(function (a, b) { return (a.score < b.score) ? 1 : ((b.score < a.score) ? -1 : 0); });
                ctrl.showGenerateBtn = true;
                ctrl.menu = [];
                ctrl.stopLoadingSpinner();
                ctrl.showTable();
                ctrl.$scope.$apply();
            }
        })["catch"](function (err) {
            ctrl.stopLoadingSpinner();
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    IssueViewComponent.prototype.getCalculateImpactFactorScore = function (tornadoList) {
        var npvMax = tornadoList[0].npvSwing;
        tornadoList.forEach(function (fact) {
            fact.impactScore = Math.round((fact.npvSwing / npvMax) * 8.99 + 0.5);
        });
        return tornadoList;
    };
    IssueViewComponent.prototype.initSelectFactors = function () {
        var ctrl = this;
        if (ctrl.currExperiment.issueFactor) {
            if (ctrl.currExperiment.impactMappingList && ctrl.currExperiment.impactMappingList != "default") {
                var selectedFactorIndex = ctrl.currExperiment.impactMappingList.findIndex(function (f) { return (ctrl.currExperiment.issueFactor.key === f.key); });
                ctrl.selectedFactor = ctrl.currExperiment.impactMappingList[selectedFactorIndex];
            }
        }
        else {
            ctrl.selectedFactor = undefined;
        }
    };
    IssueViewComponent.prototype.initSelectStatus = function () {
        var ctrl = this;
        if (ctrl.currExperiment.status) {
            var selectedStatusIndex = ctrl.origStatus.findIndex(function (f) { return (ctrl.currExperiment.status === f); });
            ctrl.selectedStatus = ctrl.origStatus[selectedStatusIndex];
        }
        else {
            ctrl.selectedStatus = undefined;
        }
    };
    IssueViewComponent.prototype.clearSelection = function () {
        var ctrl = this;
        ctrl.selectedIssue = null;
        ctrl.isDirty = false;
    };
    IssueViewComponent.prototype.selectIssue = function (index) {
        var ctrl = this;
        ctrl.selectedIndex = index;
        ctrl.selectedIssue = ctrl.issueData[index];
        ctrl.selectedIssue.score = ctrl.selectedIssue.ignorance * ctrl.selectedIssue.impact;
        if (ctrl.selectedIssue.score > 0) {
            //Remove potential show stopper
            if (Array.isArray(ctrl.selectedIssue.impactMappingList)) {
                var pssIndex = ctrl.selectedIssue.impactMappingList.findIndex(function (x) { return x.key == 'potentialShowStopper'; });
                if (pssIndex > -1) {
                    ctrl.selectedIssue.impactMappingList.splice(pssIndex, 1);
                }
            }
            $("#experimentInput").focus();
            ctrl.currExperiment = ctrl.utilsService.getIssueDetails(ctrl.selectedIssue, ctrl.fteGlobal);
            ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
            ctrl.initSelectFactors();
            ctrl.initSelectStatus();
            ctrl.expSelected = true;
        }
        else {
            ctrl.selectedIssue = null;
            ctrl.showAlert('warning', 'Low Surprise Index!', 'Surprise index must be higher than 0 to define an experiment"');
        }
        ctrl.$scope.$apply();
    };
    IssueViewComponent.prototype.updateCurrExp = function () {
        var ctrl = this;
        ctrl.expSelected = true;
        ctrl.checkSave();
    };
    IssueViewComponent.prototype.updateIssueData = function () {
        var ctrl = this;
        var updatedIssueData = angular.copy(ctrl.issueData);
        var experimentData = {};
        var definedScore = ctrl.getDefined();
        experimentData['name'] = ctrl.currExperiment['expName'];
        experimentData['_id'] = ctrl.currExperiment['expId'];
        experimentData['cost'] = ctrl.currExperiment['cost'];
        experimentData['costBefore'] = ctrl.currExperiment['costBefore'];
        experimentData['resourceFte'] = ctrl.currExperiment['resourceFte'];
        experimentData['resourceFteBefore'] = ctrl.currExperiment['resourceFteBefore'];
        experimentData['startDatePotential'] = ctrl.currExperiment['startDatePotential'];
        experimentData['totalCost'] = ctrl.currExperiment['totalCost'];
        experimentData['totalCostBefore'] = ctrl.currExperiment['totalCostBefore'];
        experimentData['duration'] = ctrl.currExperiment['duration'];
        experimentData['durationBefore'] = ctrl.currExperiment['durationBefore'];
        updatedIssueData[ctrl.selectedIndex]['includeInSprint'] = ctrl.currExperiment['includeInSprint'];
        updatedIssueData[ctrl.selectedIndex]['issueFactor'] = ctrl.currExperiment['issueFactor'];
        updatedIssueData[ctrl.selectedIndex]['issueDescription'] = ctrl.currExperiment['issueDescription'];
        experimentData['needToLearn'] = ctrl.currExperiment['needToLearn'];
        experimentData['goingToLearn'] = ctrl.currExperiment['goingToLearn'];
        experimentData['toMeasure'] = ctrl.currExperiment['toMeasure'];
        experimentData['successCriteria'] = ctrl.currExperiment['successCriteria'];
        experimentData['estCompDate'] = ctrl.currExperiment['estCompDate'];
        experimentData['startActiveDate'] = ctrl.currExperiment['startActiveDate'];
        experimentData['status'] = angular.copy(ctrl.currExperiment['status']);
        if (definedScore >= 100) {
            if (experimentData['status'] !== ctrl.origStatus[0] && experimentData['status'] !== ctrl.origStatus[1]) {
                experimentData['status'] = experimentData['inIterationPlan'] ? ctrl.origStatus[1] : ctrl.origStatus[2];
            }
        }
        else {
            experimentData['status'] = ctrl.origStatus[3];
            updatedIssueData[ctrl.selectedIndex]['inIterationPlan'] = false;
        }
        experimentData['defined'] = definedScore;
        experimentData['updatedAt'] = new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
        updatedIssueData[ctrl.selectedIndex]['experimentData'] = [experimentData];
        return updatedIssueData;
    };
    IssueViewComponent.prototype.updateIterPlanInIssueData = function () {
        var ctrl = this;
        var updatedIssueData = angular.copy(ctrl.issueData);
    };
    IssueViewComponent.prototype.resetBack = function () {
        var ctrl = this;
        ctrl.currExperiment = angular.copy(ctrl.origCurrExperiment);
        ctrl.clearSelection();
    };
    IssueViewComponent.prototype.saveCurrentExp = function () {
        var ctrl = this;
        ctrl.updatedIssueData = ctrl.utilsService.updateIssueData(ctrl.issueData, ctrl.selectedIndex, ctrl.currExperiment, ctrl.fteGlobal);
        ctrl.issueData = angular.copy(ctrl.updatedIssueData);
        ctrl.saveExperimentData();
    };
    IssueViewComponent.prototype.saveExperimentData = function () {
        var ctrl = this;
        var issueToBeSaved = angular.copy(ctrl.issueData[ctrl.selectedIndex]);
        var experimentToBeSaved = issueToBeSaved['experimentData'][0];
        if (experimentToBeSaved['_id'] == '') {
            delete experimentToBeSaved['_id'];
        }
        this.smartorg.saveInavExperimentData(issueToBeSaved['_id'], experimentToBeSaved).then(function (res) {
            if (res.status == 0) {
                ctrl.isDirty = false;
                ctrl.setGlobalDirty();
                ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
                ctrl.showAlert('success', 'Saved!', 'Details saved for issue "' +
                    ctrl.issueData[ctrl.selectedIndex]['name'] + '"');
                ctrl.clearSelection();
                ctrl.isDataLoaded = false;
                ctrl.getIssueDetailsFromDb();
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    IssueViewComponent.prototype.onFteChange = function () {
        var ctrl = this;
        ctrl.utilsService.onFteChange(ctrl.currExperiment, ctrl.fteGlobal, function () { ctrl.checkSave(); });
    };
    IssueViewComponent.prototype.checkSave = function () {
        var ctrl = this;
        //excluding impact mapping list on checkSave, as no need to go inside object
        ctrl.isDirty = this.utilsService.checkSave(__assign(__assign({}, ctrl.currExperiment), { impactMappingList: [] }), __assign(__assign({}, ctrl.origCurrExperiment), { impactMappingList: [] }));
        ctrl.setGlobalDirty();
    };
    /**
     * @description Add calculated impact factor score and sort mapping list according to score
     * @param mappingList Impact factor mapping list
     */
    IssueViewComponent.prototype.getImpactMappingListWithImpactScore = function (item) {
        var ctrl = this;
        var mappingList = item.impactMappingList;
        if (Array.isArray(mappingList)) {
            mappingList.forEach(function (impactFact) {
                if (impactFact.key !== 'potentialShowStopper') {
                    impactFact.impactScore = ctrl.impactFactorScoreList.find(function (x) { return x.name == impactFact.display; }).impactScore;
                }
            });
            ctrl.utilsService.sortList(mappingList, 'impactScore');
        }
        if (item.isPotentialShowStopper) {
            mappingList = ctrl.getMappingListWithAbilityToLaunch(item);
            ctrl.utilsService.sortList(mappingList, 'impactScore');
        }
        return mappingList;
    };
    IssueViewComponent.prototype.getMappingListWithAbilityToLaunch = function (item) {
        var ctrl = this;
        var mappingList = item.impactMappingList;
        var abilityToLaunchItem = {
            key: 'potentialShowStopper',
            display: 'Potential Show Stopper',
            impactScore: ctrl.getAbilityToLaunchScore(item.abilityToLaunch),
            reason: item.abilityToLaunch.reason
        };
        if (Array.isArray(mappingList)) {
            mappingList.push(abilityToLaunchItem);
        }
        else {
            mappingList = [abilityToLaunchItem];
        }
        return mappingList;
    };
    IssueViewComponent.prototype.getAbilityToLaunchScore = function (abilityToLaunch) {
        var impactScore = 0;
        switch (abilityToLaunch.key) {
            case 'hardSt':
                impactScore = 8;
                break;
            case 'mediumSt':
                impactScore = 5;
                break;
            case 'easySt':
                impactScore = 2;
                break;
        }
        return impactScore;
    };
    IssueViewComponent.prototype.getImpactMappingList = function (item, index) {
        var res;
        if (Array.isArray(item.impactMappingList) && item.impactMappingList[index]) {
            res = item.impactMappingList[index];
            var isPotentialShowStopper = (res.key == 'potentialShowStopper');
            res = res.display + "<>" + res.impactScore + "<>" + isPotentialShowStopper + "<>" + (isPotentialShowStopper ? res.reason.optimism : res.reason.high) + "<>" + (isPotentialShowStopper ? res.reason.pessimism : res.reason.low);
        }
        return res;
    };
    return IssueViewComponent;
}());
angular.module('smartorg.r6.acts.issueView', []).component('issueView', {
    template: require('./issue-view.component.html'),
    controller: IssueViewComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = 'smartorg.r6.acts.issueView';
//# sourceMappingURL=issue-view.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/issue-view/issue-view.component.js